import React, { Component } from "react";
import { connect } from "react-redux";

import { Button, DatePicker, Space, Spin } from "antd";
import { SearchOutlined } from "@ant-design/icons";

import { loadLots } from "../../store/actions/lotAction";
import { columns } from "./columns";

import Highlighter from "react-highlight-words";
import ListLot from "../../components/ListLot";

import dayjs from "dayjs";

const dateFormat = "DD/MM/YYYY";

class LotsListe extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchText: "",
      searchedColumn: "",
    };
  }

  datePickerRef = React.createRef();

  componentDidMount() {
    this.props.loadLots();
  }

  getTableOption = (columns, champsPersosGroupes) => {
    const newColumns = champsPersosGroupes.flatMap((groupe) =>
      groupe.champ_perso
        .filter((champ) => champ.champ_perso_liste_lot)
        .map((champ) =>
          champ.champ_perso_type === 5
            ? {
                title: champ.champ_perso_libelle,
                dataIndex: "lot_champs_persos",
                key: champ.champ_perso_libelle.toLowerCase().replace(/\s+/g, "_"),
                ...this.getColumnSearchPropsDate("lot_champs_persos", champ.champ_perso_id),
                render: (lot_champs_persos) => {
                  const item = lot_champs_persos.find(
                    (item) =>
                      item.lot_champ_perso_champ_perso.champ_perso_id === champ.champ_perso_id
                  );
                  return item ? dayjs(item.lot_champ_perso_valeur).format("DD/MM/YYYY") : "";
                },
              }
            : {
                title: champ.champ_perso_libelle,
                dataIndex: "lot_champs_persos",
                key: champ.champ_perso_libelle.toLowerCase().replace(/\s+/g, "_"),
                render: (lot_champs_persos) => {
                  const item = lot_champs_persos.find(
                    (item) =>
                      item.lot_champ_perso_champ_perso.champ_perso_id === champ.champ_perso_id
                  );
                  return item ? item.lot_champ_perso_valeur : "";
                },
              }
        )
    );

    return [...columns, ...newColumns];
  };

  getColumnSearchPropsDate = (dataIndex, champ_perso_id) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <DatePicker
          ref={this.datePickerRef}
          placeholder={`Rechercher ${dataIndex}`}
          format={dateFormat}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e ? [e] : [])}
          onPressEnter={() => this.handleSearchDate(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearchDate(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Rechercher
          </Button>
          <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) => this.onSearchDate(value, record, champ_perso_id),
    filterDropdownProps: {
      onOpenChange: (open) => {
        if (open) {
          setTimeout(() => this.datePickerRef.current.focus(), 100);
        }
      },
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearchDate = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0]?.format("DD/MM/YYYY"),
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  onSearchDate = (record, value, champ_perso_id) => {
    const champ_perso = value.lot_champs_persos.find(
      (item) => item.lot_champ_perso_champ_perso.champ_perso_id === champ_perso_id
    );
    const date = champ_perso?.lot_champ_perso_valeur;

    return record ? record.startOf("day").isSame(dayjs(date).startOf("day")) : "";
  };

  render() {
    const { champsPersosGroupes, lots } = this.props;

    return (
      <Spin size="large" tip="Chargement en cours..." spinning={!lots}>
        <ListLot
          listData={
            lots &&
            lots
              .filter((item) => !item.lot_fin)
              .sort((a, b) => a.lot_reference.localeCompare(b.lot_reference))
          }
          tableOption={this.getTableOption(columns, champsPersosGroupes)}
        />
      </Spin>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadLots: () => dispatch(loadLots()),
  };
};

// mapper le state aux props du component
const mapStateToProps = (state) => {
  return {
    utilisateur: state.utilisateur.data,
    champsPersosGroupes: state.champsPersosGroupes.data,
    lots: state.lots.data,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LotsListe);
